<svelte:options accessors />

<script lang="ts">
	import { getContext } from 'svelte'
	import { page } from '$app/stores'
	import type { ActionResult } from '@sveltejs/kit'
	import type { Writable } from 'svelte/store'
	import ValidationMessage from './ValidationMessage.svelte'

	//Props
	export let name: string
	export let disabled = false
	export let cursor = disabled ? 'cursor-default' : 'cursor-pointer'
	export let value: string | null = 'true'

	//Stores
	export let fail: Writable<Extract<ActionResult, { type: 'failure' }>> = getContext('fail')
	export let formData: Writable<Record<string, any>> = getContext('formData')

	//Classes
	export let textSize = 'text-sm'
	export let color = 'text-neutral-500'
	export let margin = 'my-3'

	//Functions
	export function focus() {
		inputThis.focus()
		inputThis.select()
	}

	let inputThis: HTMLInputElement
</script>

<label class="{margin} {cursor} inline-flex items-center gap-3">
	<input
		class="{cursor} h-7 w-7 shrink-0 appearance-none outline-none transition-colors duration-500"
		class:border-primary-500={$fail?.data?.[name] || $page.form?.[name]}
		type="checkbox"
		{name}
		{value}
		{disabled}
		bind:checked={$formData[name]}
		on:click
		on:change={() => {
			if ($fail?.data?.[name]) $fail.data[name] = ''
		}}
	/>
	<span class="font-semibold {color} {textSize}">
		<slot />
		<div class="w-full">
			<ValidationMessage {name} />
		</div>
	</span>
</label>

<style>
	input {
		box-shadow: theme('boxShadow.sm');
		font-size: theme('fontSize.xl');
		background: white;
		color: theme('colors.primary-500');
		border-radius: theme('borderRadius.md');
		border-color: theme('colors.neutral.300');
		border-width: theme('borderWidth.2');
	}
	input:checked,
	input:disabled {
		background-color: theme('colors.primary-500');
		background-image: url('$static/images/icons/check.svg') !important;
		background-size: 75%, 75%;
		background-position: center;
		background-repeat: no-repeat;
	}

	input:disabled {
		background-color: theme('colors.primary-800');
	}
</style>
